export default __webpack_public_path__ + "static/wwc-image8-0ab712044cfe0b48c828b16dff5b94a9.jpg";